module.exports = __webpack_public_path__ + "img/EventWinPage1204.ad5dc989.png";